import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { InputPhoneNumberComponent } from "@shared/controls/input-phone-number/input-phone-number.component";
import { InputComponent } from "@shared/controls/input/input.component";
import { SelectComponent } from "@shared/controls/select/select.component";
import { OrganisationApiService } from "@shared/services/organisation-api.service";
import { UsersApiService } from '@shared/services/users-api.service';
import { CustomFormValidators } from "@shared/validators/custom-form-validators";
import { firstValueFrom } from 'rxjs';
import { ApproverStatus } from '@models/documents/approver-status.enum';
import { SelectOption } from "@models/ui-models/select-options";
import { Signatory } from "@models/documents/sign-documents";
import { UserRecord } from '@models/organisations/user-record';
import { CommonModalFormComponent } from "@shared/components/commons/common-modal-form/common-modal-form.component";

@Component({
  selector: 'app-add-approver',
  standalone: true,
  imports: [
    CommonModalFormComponent,
    ReactiveFormsModule,
    SelectComponent,
    FormsModule,
    InputComponent,
    InputPhoneNumberComponent
  ],
  templateUrl: './add-approver-modal.component.html',
  styleUrl: './add-approver-modal.component.scss'
})
export class AddApproverModalComponent implements OnInit {
  @Output() confirm = new EventEmitter<Signatory>();

  private fb: FormBuilder = inject(FormBuilder);
  private activeModal = inject(NgbActiveModal);
  private usersService = inject(UsersApiService);
  private organisationService = inject(OrganisationApiService);

  profileUserList: UserRecord[] = [];
  approverOptions: SelectOption[] = [];
  selectedApprover = '';

  form!: FormGroup

  async ngOnInit(): Promise<void> {
    this.form = this.fb.group({
      id: ['', Validators.required],
      fullName: ['', Validators.required],
      email: ['', [Validators.required, CustomFormValidators.emailValidator]],
      phone: [''],
    });

    this.profileUserList = await firstValueFrom(this.usersService.getAssignableUsersCached());
    this.approverOptions = this.profileUserList.map(profile => ({
      label: profile.fullName,
      value: profile.id
    }));

    this.selectedApprover = this.profileUserList[0].id!;
    this.onApproverSelect(this.profileUserList[0].id!);
  }

  onApproverSelect(id: string): void {
    const user = this.profileUserList.find(user => user.id === id);
    if (user) {
      this.form.get('id')?.patchValue(id);
      this.form.get('fullName')?.patchValue(user.fullName);
      this.form.get('email')?.patchValue(user.email);
    }
  }

  add(): void {
    var approver = this.form.getRawValue() as Signatory;
    approver.status = ApproverStatus.Created;
    this.confirm.emit(approver);
    this.activeModal.close();
  }

  close(): void {
    this.activeModal.close();
  }
}
